// extracted by mini-css-extract-plugin
module.exports = {"title":"JobCardContent_title__DM8sb","label":"JobCardContent_label__2ta1x","attributes":"JobCardContent_attributes__1wwID","sending":"JobCardContent_sending__3zxKj"};